export default defineAppConfig({
  title: "Loyalty",
  theme: {
    colors: {
      primary: "#e72b6f",
    },
  },
});
